import { Mui, MuiIcons } from "@osu/react-ui";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectBuckeyeLinkLinks } from "../../../../services/graphql/slices/buckeye-link";
import { autocompleteGroupSx } from "../styles/responsiveness";

function Autocomplete({ sortedLinks = [], onAdd, autocompleteRef }) {
  const id = "quick-links";
  const autocompleteOptions = useSelector((state) => {
    let _buckeyeLinks = selectBuckeyeLinkLinks(state) ?? [];
    let buckeyeLinks = _buckeyeLinks.filter((bl) => {
      const matchInList = (sortedLinks ?? []).find(
        (link) => link.link === bl.link
      );
      return !matchInList;
    });

    return buckeyeLinks.sort((a, b) => -b.category.localeCompare(a.category));
  });
  const [newLinks, setNewLinks] = useState([]);

  return (
    <Mui.FormControl className="margin-y-2 width-100" sx={autocompleteGroupSx}>
      <Mui.Autocomplete
        disablePortal
        id={id + "-autocomplete"}
        multiple
        filterSelectedOptions
        value={newLinks}
        onChange={(event, newValue) => {
          setNewLinks(newValue);
        }}
        isOptionEqualToValue={(option, value) => {
          return value?.link && option.link === value?.link;
        }}
        getOptionLabel={(option) => option?.title}
        options={autocompleteOptions}
        fullWidth
        sx={{
          flexGrow: 2
        }}
        groupBy={(option) => {
          return option?.category
        }}
        renderInput={(params) => (
          <Mui.TextField
            {...params}
            inputRef={autocompleteRef}
            label="Search through available options to add to your Quick Links"
          />
        )}
        slotProps={{
          paper: {
            elevation: 12
          },
          // listbox: {
          //   sx: (theme) => ({
          //     [`& *.${Mui.listSubheaderClasses.root}.${Mui.autocompleteClasses.groupLabel}`]: {
          //       color: 'red !important'
          //     }
          //   })
          // }
        }}
      />
      <Mui.Button
        variant="outlined"
        startIcon={<MuiIcons.Add />}
        disabled={!newLinks.length}
        onClick={() => {
          setNewLinks(stateOfLinks => {
            onAdd(stateOfLinks)
            return []
          });
          autocompleteRef.current.focus()
        }}
      >
        Add
      </Mui.Button>
    </Mui.FormControl>
  );
}

export default Autocomplete;
